import type { AuthPermissionUser } from '../../services/authPermissions';

// UX mirror of backend/src/middleware/factoryAccess.js. ORDER_STAFF
// (Handlowiec) can list/create/edit factories; deletion stays ADMIN-only.
// The backend is the boundary.
const FACTORY_MANAGEMENT_ROLES = ['MARKETING', 'ADMIN', 'OPERATIONS', 'ORDER_STAFF'];

export function canViewFactories(user: AuthPermissionUser | null | undefined): boolean {
  return FACTORY_MANAGEMENT_ROLES.includes(user?.role || '');
}

export function canManageFactories(user: AuthPermissionUser | null | undefined): boolean {
  return FACTORY_MANAGEMENT_ROLES.includes(user?.role || '');
}

export function canDeleteFactories(user: AuthPermissionUser | null | undefined): boolean {
  return user?.role === 'ADMIN';
}
